module.exports = "/lucky-balls/img/regular_game/number_picked.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/number_picked.png
// module id = 1153
// module chunks = 0